import { HttpError, useOne } from "@refinedev/core";
import { IEventDetail, IOrgIdsItem, IPartnerIdsItem } from "interfaces";
import { formatNumber } from "utills/helpers";

export const InternalSetup = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  const { data: orgIds } = useOne<IOrgIdsItem[], HttpError>({
    resource: "organization/ids",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const { data: partnerData } = useOne<IPartnerIdsItem[], HttpError>({
    resource: "partner/dropdown",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const organizationIds = (orgIds?.data ?? []).map((org: IOrgIdsItem) => ({
    value: org.id,
    label: org.name_en,
  }));

  const partnerIds = (partnerData?.data ?? []).map((partner) => ({
    value: partner.id,
    label: partner.name,
  }));

  return (
    <div className="box-container p-4 sm:p-6">
      <div className="flex flex-col justify-center items-start">
        <div className="w-full flex flex-row items-start gap-x-2">
          <p className="w-40 shrink-0 font-bold">Organization:</p>
          <p>
            {
              organizationIds.find(
                (organization) =>
                  organization.value === eventDetailData?.merchant_id
              )?.label
            }
          </p>
        </div>
        <div className="w-full flex flex-row items-start gap-x-2 mt-2">
          <p className="w-40 shrink-0 font-bold">Apply for partner:</p>
          <div>
            {partnerIds
              .filter((partner) =>
                (eventDetailData?.apply_for_partners ?? []).includes(
                  partner.value
                )
              )
              .map((partner, index) => (
                <p className="text-sm inline" key={partner.value}>
                  {index !== 0 ? <span className="mx-2">•</span> : ""}
                  {partner.label}
                </p>
              ))}
          </div>
        </div>
        <div className="w-full flex flex-row items-start gap-x-2 mt-2">
          <p className="w-40 shrink-0 font-bold">MTB id:</p>
          <p>{eventDetailData?.mtb_id}</p>
        </div>
      </div>
    </div>
  );
};
